export default __webpack_public_path__ + "static/media/VN.5367c130.svg";